import React from 'react';
import {TaskModalEstimatePlaceholder} from '../placeholders/TaskModalEstimatePlaceholder';
import {TaskModalTimeEntriesPlaceholder} from '../placeholders/TaskModalTimeEntriesPlaceholder';
import {TaskModalRemainingPlaceholder} from '../placeholders/TaskModalRemainingPlaceholder';

export const TaskRollupSectionPlaceholder = () => {
	return (
		<>
			<TaskModalEstimatePlaceholder />
			<TaskModalTimeEntriesPlaceholder />
			<TaskModalRemainingPlaceholder />
		</>
	);
};
